/**
 * `src/styles/Sider.css` pins every `.ant-modal-wrap` to a very high z-index,
 * which would leave modal popups (selects, pickers) buried underneath.
 * SEMAFIX modals therefore opt into that same layer explicitly so antd can
 * raise their popups above it through its own z-index context.
 */
export const MODAL_Z_INDEX = 10000000;
export const NESTED_MODAL_Z_INDEX = 10000100;
export const MODAL_POPUP_CLASS = 'semafix-modal-popup';
